import { render, staticRenderFns } from "./IntervalSettings.vue?vue&type=template&id=b6f075ca&scoped=true&"
import script from "./IntervalSettings.vue?vue&type=script&lang=js&"
export * from "./IntervalSettings.vue?vue&type=script&lang=js&"
import style0 from "./IntervalSettings.vue?vue&type=style&index=0&id=b6f075ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f075ca",
  null
  
)

export default component.exports